module.exports = __webpack_public_path__ + "static/media/grid.7c3c6775.svg";